(() => {
  'use strict';

  document.querySelectorAll('[data-goat-age-finder]').forEach((root) => {
    const form = root.querySelector('[data-age-form]');
    const ageSelect = root.querySelector('[data-age-select]');
    const interestSelect = root.querySelector('[data-interest-select]');
    const cards = [...root.querySelectorAll('[data-age-card]')];
    const empty = root.querySelector('[data-age-empty]');
    const kicker = root.querySelector('[data-age-result-kicker]');
    const heading = root.querySelector('[data-age-result-heading]');
    const reset = root.querySelector('[data-age-reset]');
    const limit = Math.max(1, Number(root.dataset.resultLimit || 3));

    if (!form || !ageSelect || !cards.length) return;

    const hideAll = () => cards.forEach((card) => { card.hidden = true; });

    const recommend = () => {
      const age = Number(ageSelect.value);
      const interest = interestSelect?.value || 'all';
      if (!age) {
        ageSelect.focus();
        return;
      }

      const scored = cards.map((card, index) => {
        const min = Number(card.dataset.minAge || 1);
        const max = Number(card.dataset.maxAge || 17);
        const cardInterest = card.dataset.interest || 'all';
        const exactAge = age >= min && age <= max;
        const distance = exactAge ? 0 : Math.min(Math.abs(age - min), Math.abs(age - max));
        const midpoint = (min + max) / 2;
        let score = exactAge ? 120 - Math.abs(age - midpoint) * 3 : 30 - distance * 15;
        if (interest === 'all' || cardInterest === 'all') score += 8;
        if (interest !== 'all' && cardInterest === interest) score += 45;
        if (card.dataset.featured === 'true') score += 7;
        return { card, index, score, exactAge, distance, interestMatch: interest === 'all' || cardInterest === interest || cardInterest === 'all' };
      });

      let pool = scored.filter((item) => item.exactAge && item.interestMatch);
      if (!pool.length) pool = scored.filter((item) => item.exactAge);
      if (!pool.length) pool = scored;
      pool.sort((a, b) => b.score - a.score || a.distance - b.distance || a.index - b.index);

      hideAll();
      pool.slice(0, limit).forEach(({ card }, position) => {
        card.hidden = false;
        card.style.setProperty('--goat-result-order', String(position));
      });
      if (empty) empty.hidden = true;
      if (reset) reset.hidden = false;
      if (kicker) kicker.textContent = interest === 'all' ? `Best matches for age ${age}` : `Age ${age} · ${interestSelect.options[interestSelect.selectedIndex].text}`;
      if (heading) heading.textContent = `We found ${Math.min(limit, pool.length)} strong GOAT ${Math.min(limit, pool.length) === 1 ? 'candidate' : 'candidates'}.`;
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      recommend();
    });

    ageSelect.addEventListener('change', () => {
      if (ageSelect.value) recommend();
    });

    interestSelect?.addEventListener('change', () => {
      if (ageSelect.value) recommend();
    });

    reset?.addEventListener('click', () => {
      form.reset();
      hideAll();
      if (empty) empty.hidden = false;
      if (reset) reset.hidden = true;
      if (kicker) kicker.textContent = 'Fast, useful, no endless scrolling';
      if (heading) heading.textContent = 'Your recommendations will appear here.';
      ageSelect.focus();
    });

    hideAll();
  });
})();
